// Custom Colors = [RLGold,RLWhite]
/* social link custom colors {
   circle colors: [RLWhite]
   icon colors: [RLRed]
}*/
export const PROFILE = {
    title: {
        title: '',
        color: '',
        font: '',
    },
    TRCLogo: 'white',
    profilePic:
        'https://res.cloudinary.com/rightlink/image/upload/v1686521009/The_Right_Click_-_symbol_ujlnqa.png',
    background: {
        imageLink:
            'background-image: url(https://res.cloudinary.com/rightlink/image/upload/v1686520694/RightClick/IMG_0130_ium0en.jpg)',
        imageSize: '',
        logoLink: '',
        logoActiveLink: '',
        color: '',
    },
};
export const SOCIAL_LINKS = {
    position: 'bottom',
    group: [
        {
            name: 'Instagram',
            iconName: 'instagram',
            link: 'https://www.instagram.com/__pierre9',
            color: 'green',
            inverted: true,
            secondaryColor: '',
            surrounded: 'circular',
            surroundedInColor: true,
        },
    ],
};
// featuredTimerDate formats inclued '2020-02-01T01:02:03' or milliseconds e.g 1580518923000 - documentation here https://github.com/ndresx/react-countdown
// for media as links you must set type as 'item' and mainMedia.type as either 'still, mp4, or other(not implemented yet)'
// using a new Link_group setup
export const LINK_GROUPS = [
    {
        groupName: '',
        groupColor: '',
        groupFont: '',
        group: [
            {
                name: 'Our Mission',
                link: 'https://res.cloudinary.com/rightlink/image/upload/v1686522254/RightClick/right_link_typetrial_2_xywtag.png',
                linkSpaced: true,
                type: 'bio',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: 'red',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: 'green',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: '',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [
                    {
                        header: 'Mission Statement',
                        subHeader:
                            'At The Right Click, our mission is to empower small businesses with the knowledge, tools, and strategies to thrive in the digital age. We combine our expertise in tech consulting and small business coaching to deliver tailored solutions that drive growth, enhance efficiency, and foster long-term success. Our commitment is to provide exceptional guidance and support, empowering small business owners to leverage technology, optimize their operations, and achieve their business goals.',
                    },
                    {
                        header: 'Bio',
                        subHeader:
                            "The Right Click is a trusted provider of tech consulting and small business coaching services. With a deep understanding of the challenges faced by small businesses in today's fast-paced digital landscape, we offer expert guidance and practical solutions to help entrepreneurs navigate the complexities of technology and drive their businesses forward.",
                    },
                    {
                        header: '',
                        subHeader:
                            "Our team of experienced consultants brings a wealth of knowledge in information systems, technology, and business strategy. We work closely with small business owners, providing personalized coaching and consulting services tailored to their unique needs and goals. Whether you're looking to streamline your operations, enhance your online presence, implement efficient software solutions, or develop effective marketing strategies, we're here to guide you every step of the way.",
                    },
                    {
                        header: '',
                        subHeader:
                            'At The Right Click, we believe that technology is a powerful enabler for small businesses. We combine our tech expertise with a deep understanding of business principles to deliver comprehensive solutions that deliver tangible results. From assessing your current technology infrastructure to developing growth strategies, our holistic approach ensures that you have the tools and knowledge to thrive in the competitive business landscape.',
                    },
                    {
                        header: '',
                        subHeader:
                            'We take pride in our commitment to building strong relationships with our clients, providing ongoing support, and serving as a trusted partner on their business journey. Our passion for helping small businesses succeed is at the heart of everything we do.',
                    },
                    {
                        header: '',
                        subHeader:
                            "If you're ready to take your small business to new heights, let us be your guide. Contact The Right Click today to schedule a consultation and discover how our tech consulting and small business coaching services can unlock your business's full potential.",
                    },
                ],
            },
            {
                name: 'Our Services',
                link: 'https://res.cloudinary.com/rightlink/image/upload/v1686522254/RightClick/right_link_typetrial_2_xywtag.png',
                linkSpaced: true,
                type: 'still/internal',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: 'red',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {
                    type: 'still',
                    link: 'https://res.cloudinary.com/rightlink/image/upload/v1686522254/RightClick/right_link_typetrial_2_xywtag.png',
                    mediaText: '',
                    videoPoster: '',
                },
                additionalLinks: [
                    {
                        name: 'Get Started Today!',
                        link: 'https://tidal.com',
                    },
                    {
                        name: 'Other Services',
                        link: 'https://www.rightclickrva.com/business',
                    },
                ],
                color: 'green',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: '',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Client Resources',
                link: '',
                linkSpaced: true,
                type: 'internal',
                typeAction: '',
                internal: true,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {
                    type: 'still',
                    link: 'https://res.cloudinary.com/rightlink/image/upload/v1686528354/RightClick/A3_-_The_Right_Click_-_Main_Logo_Design_-_Color_White_BG_copy_fkrx7p.jpg',
                    mediaText: '',
                },
                additionalLinks: [
                    {
                        name: 'Cash App',
                        link: 'https://cash.app/$vcuPierre',
                    },
                    {
                        name: 'Venmo',
                        link: 'https://account.venmo.com/u/Pierre-Randall',
                    },
                    {
                        name: 'Paypal',
                        link: 'https://www.paypal.me/vcupierre',
                    },
                ],
                color: 'green',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Right Click Website',
                link: 'https://www.rightclickrva.com/business',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: 'green',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'View My Resume',
                link: 'https://drive.google.com/file/d/1spir6Exs4KearSCC3rkUqYEF89-Ctp5K/view?usp=drive_link',
                linkSpaced: true,
                type: 'external',
                typeAction: 'download',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {},
                additionalLinks: [],
                color: 'green',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Business Tech Bundle',
                link: 'https://drive.google.com/file/d/1Y9VPOi68XWXuS3cPhlJb8dsnMMUNKPSw/view?usp=drive_link',
                linkSpaced: true,
                type: 'external',
                typeAction: 'download',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: false,
                mainMedia: {},
                additionalLinks: [],
                color: 'green',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
        ],
    },
];
